export function formatPhoneNumber(value?: string | null): string | null {
  if (!value) {
    return null;
  }

  const digits = value.replace(/\D+/g, '');
  if (!digits) {
    return null;
  }

  const formatCore = (core: string) =>
    `(${core.slice(0, 3)})-${core.slice(3, 6)}-${core.slice(6, 10)}`;

  if (digits.length === 11 && digits.startsWith('1')) {
    const core = digits.slice(1, 11);
    return `+1 ${formatCore(core)}`;
  }

  if (digits.length >= 10) {
    const core = digits.slice(-10);
    return formatCore(core);
  }

  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  if (digits.length > 3) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return digits;
}
